<owl-carousel-o *ngIf="carouselEnable" #owlCarousel [options]="customOptions">
    <ng-container *ngFor="let slide of slidesStore; let i = index">
        <ng-template carouselSlide [id]="'hero-img-' + (i + 1)" [dotContent]="'0' + (i + 1)">
            <img [src]="slide | imageSource" alt=""
                class="w-full h-full ltr:lg:rounded-l-[5px] rtl:lg:rounded-r-[5px]" />
        </ng-template>
    </ng-container>
</owl-carousel-o>